import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, MessageCircle } from "lucide-react";
import { NAV_LINKS, LOGO_URL, CONTACT, waLink } from "../data/content";

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-500 bg-white border-b border-graytone-medium/60 shadow-soft"
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <a href="#beranda" data-testid="nav-logo" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="FYLegal.ID" className="h-11 w-11 rounded-full object-cover ring-1 ring-graytone-medium" />
          <span className="hidden sm:flex flex-col leading-none">
            <span className="font-serif text-xl font-semibold text-navy tracking-tight">
              FY<span className="text-gold-dark">Legal.ID</span>
            </span>
            <span className="text-[10px] uppercase tracking-[0.22em] text-graytone-dark mt-0.5">
              For Your Legal Needs
            </span>
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`nav-link-${l.href.replace("#", "")}`}
                className="text-sm font-medium text-navy/80 hover:text-gold-dark transition-colors relative group"
              >
                {l.label}
                <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-gold transition-all duration-300 group-hover:w-full" />
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <a
            href={waLink()}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-wa-btn"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-navy text-white px-5 py-2.5 text-sm font-semibold hover:bg-gold hover:text-navy transition-all duration-300 shadow-soft"
          >
            <MessageCircle className="h-4 w-4" />
            Konsultasi
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 text-navy"
            aria-label="Menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="lg:hidden overflow-hidden bg-white border-t border-graytone-medium"
            data-testid="mobile-menu"
          >
            <ul className="px-6 py-4 flex flex-col gap-1">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={() => setOpen(false)}
                    className="block py-3 text-navy font-medium border-b border-graytone-medium/50"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <a
                href={waLink()}
                target="_blank"
                rel="noreferrer"
                className="mt-3 inline-flex justify-center items-center gap-2 rounded-full bg-gold text-navy px-5 py-3 font-semibold"
              >
                <MessageCircle className="h-4 w-4" /> {CONTACT.phoneDisplay}
              </a>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
